import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {useFormSummaryContent} from '@/content/formSummary'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {Currency} from '@/utils/currency'
import {IpOfficePriceIncreaseAlertType} from '@/utils/registration-request/types'
import {USER_TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {FormSummaryMobile} from './mobile/FormSummaryMobile'

type FormSummaryProps = {
  totalPrice: number
  currency: Currency
  title?: string
  hasOverlay?: boolean
  hasDecimal?: boolean
  priceNote?: string
  ipOfficePriceIncreaseInfo?: IpOfficePriceIncreaseAlertType[]
}

export const FormSummary: FC<React.PropsWithChildren<FormSummaryProps>> = ({
  totalPrice,
  currency,
  title,
  hasOverlay,
  hasDecimal,
  priceNote,
  ipOfficePriceIncreaseInfo,
  children,
}) => {
  const {t} = useTranslation()
  const {summaryTitle} = useFormSummaryContent()
  const formSummaryTitle = title || t(summaryTitle)

  return (
    <>
      <div className="desktop">
        <div className="title">
          <Text variant={TextVariant.h5} element="h3">
            {formSummaryTitle}
          </Text>
        </div>
        {children}
      </div>
      <div className="mobile">
        <FormSummaryMobile
          title={formSummaryTitle}
          price={totalPrice}
          currency={currency}
          hasOverlay={hasOverlay}
          hasDecimal={hasDecimal}
          priceNote={priceNote}
          ipOfficePriceIncreaseInfo={ipOfficePriceIncreaseInfo}
        >
          {children}
        </FormSummaryMobile>
      </div>

      <style jsx>{`
        .title {
          margin-bottom: ${theme.spacing[3]};
        }
        .mobile {
          display: none;
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .desktop {
            display: none;
          }
          .mobile {
            display: block;
          }
        }
      `}</style>
    </>
  )
}
